import { Upload } from '@air/redux-uploader';
import { getAssetPreviewType } from '@air/utils-clips';

export const isPreviewAvailable = ({ apiUploadData: { type, ext } }: Upload) => {
  const webClipType = getAssetPreviewType({ type, ext });
  return webClipType === 'photo' || webClipType === 'video';
};
